import { render, staticRenderFns } from "./PasienTidakAktif5Tahun.vue?vue&type=template&id=6d95acbc"
import script from "./PasienTidakAktif5Tahun.vue?vue&type=script&lang=js"
export * from "./PasienTidakAktif5Tahun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d95acbc')) {
      api.createRecord('6d95acbc', component.options)
    } else {
      api.reload('6d95acbc', component.options)
    }
    module.hot.accept("./PasienTidakAktif5Tahun.vue?vue&type=template&id=6d95acbc", function () {
      api.rerender('6d95acbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/retensi_dan_pemusnahan/PasienTidakAktif5Tahun.vue"
export default component.exports